export default __webpack_public_path__ + "static/media/wi-rain-wind.3e23d253.svg";